/**
 * Colour-name → swatch hex (Phase 65 / BLU-594 PR2, frontend-only).
 *
 * Mirrors the `colorHexMap` inline in `Products.tsx` (kept as a small local
 * helper rather than importing a page-private constant), extended with the
 * palette Mini Zali-style DTF catalogues use. Purely decorative: a swatch dot
 * next to the always-present colour NAME (never colour as the only signal, per
 * DESIGN §16). Unknown names fall back to a neutral chip.
 */

const COLOUR_HEX: Record<string, string> = {
  black: '#1A1A1A',
  white: '#FFFFFF',
  natural: '#EDE3D0',
  cream: '#FFFDD0',
  beige: '#F5F5DC',
  sand: '#E4D5B7',
  sage: '#B9C4A7',
  navy: '#232E4A',
  charcoal: '#36454F',
  grey: '#808080',
  gray: '#808080',
  'grey marle': '#9AA0A6',
  silver: '#C0C0C0',
  red: '#D32F2F',
  maroon: '#800000',
  burgundy: '#6D1F2C',
  oxblood: '#4A0E12',
  blue: '#1E5AA8',
  'powder blue': '#9EC7E8',
  'pale blue': '#B0E0E6',
  'washed indigo': '#3E4C6B',
  indigo: '#3F51B5',
  teal: '#008080',
  forest: '#1B4332',
  'forest green': '#1B4332',
  green: '#2E7D32',
  olive: '#808000',
  bottle: '#0B3D2E',
  pine: '#12503C',
  yellow: '#F5C518',
  gold: '#D4AF37',
  orange: '#E8842B',
  terracotta: '#C56A4A',
  rust: '#B7410E',
  pink: '#E39AB5',
  lilac: '#B39DDB',
  purple: '#6A3FA0',
  plum: '#5A2A4D',
  aubergine: '#3B2233',
  brown: '#6B4423',
  espresso: '#3C2A21',
  midnight: '#0F1B2D',
  slate: '#4A5568',
  graphite: '#2E2E33',
  ebony: '#1C1A1A',
  onyx: '#1B1B1B',
};

/** Resolve a swatch hex for a colour name, or `null` when unknown (caller shows a neutral chip). */
export function colourSwatchHex(name: string | null | undefined): string | null {
  if (!name) return null;
  return COLOUR_HEX[name.trim().toLowerCase()] ?? null;
}
